import { Link } from "react-router-dom";
import { SITE } from "@/data/site";
import { Seo } from "@/components/Seo";

const Shell = ({ title, metaTitle, metaDesc, children }) => (
  <>
    <Seo title={metaTitle} description={metaDesc} />
    <section className="pt-[120px] pb-24 bg-surface-canvas min-h-screen">
      <div className="max-w-[780px] mx-auto px-5 lg:px-6">
        <h1 className="font-heading font-bold text-3xl sm:text-4xl text-brand-deep" data-testid="legal-h1">{title}</h1>
        <div className="mt-10 space-y-8 text-[15px] text-ink-secondary leading-relaxed [&_h2]:font-heading [&_h2]:font-semibold [&_h2]:text-xl [&_h2]:text-brand-deep [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5">
          {children}
        </div>
      </div>
    </section>
  </>
);

export function MentionsLegales() {
  return (
    <Shell title="Mentions légales" metaTitle="Mentions légales | HRC Rénovation" metaDesc="Mentions légales du site HRC Rénovation — SIREN 904377660, Coulounieix-Chamiers, Dordogne.">
      <div>
        <h2>Éditeur du site</h2>
        <p>
          {SITE.name}<br />
          SIREN : {SITE.siren}<br />
          Siège social : {SITE.address}<br />
          Téléphone : {SITE.phone}<br />
          Email : {SITE.email}
        </p>
      </div>
      <div>
        <h2>Directeur de la publication</h2>
        <p>{SITE.owner}, dirigeant de {SITE.name}.</p>
      </div>
      <div>
        <h2>Hébergement</h2>
        {/* TODO: préciser l'hébergeur définitif avant mise en production */}
        <p>[Hébergeur à préciser — nom, adresse et téléphone de l'hébergeur seront renseignés avant la mise en ligne définitive.]</p>
      </div>
      <div>
        <h2>Conception</h2>
        <p>Site conçu par <a href="https://alvadigital.fr" target="_blank" rel="noopener noreferrer" className="text-brand-royal underline underline-offset-2">Alva Digital</a>.</p>
      </div>
      <div>
        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des contenus de ce site (textes, images, logo) est la propriété de {SITE.name}. Toute reproduction sans autorisation est interdite.</p>
      </div>
    </Shell>
  );
}

export function Confidentialite() {
  return (
    <Shell title="Politique de confidentialité" metaTitle="Politique de confidentialité | HRC Rénovation" metaDesc="Politique de confidentialité RGPD de HRC Rénovation : données collectées, finalités, durée de conservation, vos droits.">
      <div>
        <h2>Données collectées</h2>
        <p>Via nos formulaires de devis et de contact, nous collectons : nom, prénom, adresse email, numéro de téléphone, ville, code postal et la description de votre projet.</p>
      </div>
      <div>
        <h2>Finalité du traitement</h2>
        <p>Ces données servent uniquement à répondre à votre demande de devis ou de contact. Elles ne sont ni vendues, ni transmises à des tiers à des fins commerciales.</p>
      </div>
      <div>
        <h2>Durée de conservation</h2>
        <p>Vos données sont conservées 3 ans après le dernier contact, puis supprimées.</p>
      </div>
      <div>
        <h2>Vos droits</h2>
        <p>Conformément au RGPD, vous disposez des droits suivants sur vos données :</p>
        <ul>
          <li>Droit d'accès</li>
          <li>Droit de rectification</li>
          <li>Droit de suppression</li>
          <li>Droit à la portabilité</li>
          <li>Droit d'opposition</li>
        </ul>
        <p className="mt-3">Pour exercer ces droits, contactez-nous à <a href={`mailto:${SITE.email}`} className="text-brand-royal underline underline-offset-2">{SITE.email}</a>.</p>
      </div>
      <div>
        <h2>Responsable du traitement</h2>
        <p>{SITE.owner} — {SITE.name}, {SITE.address}. Contact délégué à la protection des données : {SITE.email}.</p>
      </div>
    </Shell>
  );
}

export function CookiesPage() {
  return (
    <Shell title="Politique de cookies" metaTitle="Politique de cookies | HRC Rénovation" metaDesc="Politique de cookies du site HRC Rénovation : cookies essentiels et cookies de mesure d'audience soumis à consentement.">
      <div>
        <h2>Cookies essentiels</h2>
        <p>Ces cookies sont nécessaires au fonctionnement du site (mémorisation de votre choix de consentement). Ils sont déposés par défaut et ne collectent aucune donnée personnelle.</p>
      </div>
      <div>
        <h2>Cookies de mesure d'audience</h2>
        <p>Des cookies analytiques peuvent être déposés uniquement après votre consentement explicite via le bandeau cookies. Ils nous aident à comprendre comment le site est utilisé.</p>
      </div>
      <div>
        <h2>Gérer votre consentement</h2>
        <p>Vous pouvez modifier votre choix à tout moment en supprimant les cookies de votre navigateur, puis en revenant sur le site. Le bandeau de consentement s'affichera à nouveau.</p>
      </div>
      <div>
        <h2>Questions</h2>
        <p>Pour toute question, consultez notre <Link to="/politique-confidentialite" className="text-brand-royal underline underline-offset-2">politique de confidentialité</Link> ou écrivez-nous à {SITE.email}.</p>
      </div>
    </Shell>
  );
}
